import axios from 'axios';

const accountApi = axios.create({
	baseURL: '/api/account/v1',
	withCredentials: true,
});

export default accountApi;
